module.exports = __webpack_public_path__ + "media/images/feature-1-288f588e.png";